export default "assets/audio/vessel-alert.mp3"